<template>
  <div>
    <div class="wrapper wrapper-content  animated fadeInRight">
      <div class="ibox">
        <div class="tabs-container">
          <ul class="nav nav-tabs" role="tablist">
            <li class="active"><a class="nav-link" data-toggle="tab" @click="activeComponent = 'categories'">Categories</a></li>
          </ul>
          <div class="tab-content">
            <div class="tab-pane ibox-content active" role="tabpanel" id="feed">
              <div class="row">
                <component v-if="activeComponent" :is="activeComponent"></component>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import categories from './Tabs/Categories'

export default {
  data () {
    return {
      activeComponent: 'categories'
    }
  },
  components: {
    categories: categories
  }
}
</script>



// WEBPACK FOOTER //
// src/components/Pages/Admin/Data/Data.vue